let refreshListener = null;

export const setAuthTokenRefreshListener = listener => {
  refreshListener = typeof listener === 'function' ? listener : null;

  return () => {
    if (refreshListener === listener) refreshListener = null;
  };
};

export const notifyAuthTokenRefreshed = authToken => {
  if (authToken && refreshListener) refreshListener(authToken);
};
